import type { ClientAdminsApplicationConfigurationLoginMethod } from '@fukuri-admins/apis/client/gen/model';
import { clientFetch } from '~/api/clientFetch';

export type ApplicationConfiguration = {
  application_configuration: {
    application_name: string;
    is_api_integration: boolean;
    logo_image: { url: string };
    partner: { name: string };
    /** 初回ログインで受け付けるログイン方法（email / phone_number） */
    login_method: ClientAdminsApplicationConfigurationLoginMethod;
  };
};

export async function fetchApplicationConfiguration(
  signOut: () => void
): Promise<ApplicationConfiguration> {
  const response = await clientFetch(
    '/application_configuration',
    {
      method: 'GET',
    },
    signOut
  );
  return response.json();
}
